import React, { useCallback } from 'react';
import { Dropdown, Menu } from 'antd';
import { goLogin, goLogout } from './exportUtil'
import { canSwitchPro, setAuthPro } from './global'

const UserDropdown = (props) => {
  const { isLogin, authMap = {}, userType, userData = {} } = props
  const switchPro = useCallback(() => {
    if (canSwitchPro) {
      setAuthPro(!authMap.yk_xingyuan_pro)
    }
  }, [canSwitchPro, authMap.yk_xingyuan_pro])

  if (!isLogin) {
    return <div className="star-user-dropdown-block" onClick={goLogin}>
      <div className="user-head">
        <img className="img" src="//img.alicdn.com/imgextra/i3/O1CN01e2Seil1M7I7gBfFU2_!!6000000001387-2-tps-96-96.png" />
      </div>
      <div className="user-name">未登录</div>
    </div>
  }
  const { name, account, nickName, remainingDays } = userData
  const isTip = remainingDays <= 7
  return <Dropdown
    overlayClassName="star-user-dropdown"
    overlay={<Menu>
      <Menu.Item><a className="a" href="/star-source/person" target="_blank">个人中心</a></Menu.Item>
      <Menu.Item>
        <a className="a" href="/star-source/renewal" target="_blank">
          <div>VIP续费</div>
          {isTip ? <div className="user-dropdown-item-text">
            <div className="user-tip"></div>
            <div>还剩{remainingDays}天有效期</div>
          </div> : null}
        </a>
      </Menu.Item>
      {userType === 1 && canSwitchPro ? <Menu.Item>
        <div className="switch-btn" onClick={switchPro}>切换{authMap.yk_xingyuan_pro ? '普通' : '高级'}版</div>
      </Menu.Item> : null}
      <Menu.Item><div className="logout-text" onClick={goLogout}>退出登录</div></Menu.Item>
    </Menu>}
    placement="bottomRight"
  >
    <div className="star-user-dropdown-block">
      <div className="user-head">
        {isTip ? <div className="user-tip"></div> : null}
        <img className="img" src="//img.alicdn.com/imgextra/i3/O1CN01e2Seil1M7I7gBfFU2_!!6000000001387-2-tps-96-96.png" />
      </div>
      <div className="user-name">{nickName || name || account || '未知账号'}</div>
    </div>
  </Dropdown>
};

export default React.memo(UserDropdown)
